// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"66552d510fc2a037fb61","655":"40980fc7f4df534d8fe9"}[chunkId] + ".js";
};